import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "recipe-table-container" }
const _hoisted_2 = { class: "recipe-title" }
const _hoisted_3 = { class: "table-actions" }
const _hoisted_4 = { class: "icon-container" }
const _hoisted_5 = { class: "icon-container" }
const _hoisted_6 = { class: "icon-container" }
const _hoisted_7 = { class: "recipe-owner" }

import { Edit, Delete, View } from '@element-plus/icons-vue';
import { useAuthStore } from '@/stores/auth';
import { canUserModifyRecipe, getRecipeOwnerText } from '@/utils/recipeUtils';
import DifficultyBadge from '@/components/ui/DifficultyBadge.vue';
import type { Recipe } from '@/types/recipe';


export default /*@__PURE__*/_defineComponent({
  __name: 'RecipeTable',
  props: {
    recipes: {},
    loading: { type: Boolean },
    currentPage: {},
    pageSize: {},
    total: {}
  },
  emits: ["rowClick", "editRecipe", "deleteRecipe", "update:currentPage", "update:pageSize"],
  setup(__props: any) {

const authStore = useAuthStore();





// Check if current user can modify this recipe
const canModifyRecipe = (recipe: Recipe): boolean => {
  return canUserModifyRecipe(recipe, authStore.user);
};

const getOwnerText = (recipe: Recipe): string => {
  return getRecipeOwnerText(recipe, authStore.user);
};

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString();
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.recipes,
      style: {"width":"100%"},
      "row-style": "cursor: pointer;",
      "empty-text": "No recipes found. Create your first recipe!",
      onRowClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('rowClick', $event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "Recipe Title",
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(scope.row.title), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "difficulty_level",
          label: "Difficulty",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode(DifficultyBadge, {
              difficulty: scope.row.difficulty
            }, null, 8, ["difficulty"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "ingredientCount",
          label: "Ingredients",
          width: "120",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: "info",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.ingredientCount) + " items ", 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "creatorName",
          label: "Creator",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "createdDate",
          label: "Created",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(formatDate(scope.row.createdDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Actions",
          width: "200",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              (canModifyRecipe(scope.row))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      class: "custom-button",
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('editRecipe', scope.row)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, [
                          _createVNode(_unref(Edit), { class: "button-icon" })
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode(" Edit "))
                      ]),
                      _: 2,
                      __: [3]
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger",
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('deleteRecipe', scope.row)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, [
                          _createVNode(_unref(Delete), { class: "button-icon" })
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode(" Delete "))
                      ]),
                      _: 2,
                      __: [4]
                    }, 1032, ["onClick"])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "info",
                      class: "custom-button-secondary",
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('rowClick', scope.row)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, [
                          _createVNode(_unref(View), { class: "button-icon" })
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode(" View "))
                      ]),
                      _: 2,
                      __: [5]
                    }, 1032, ["onClick"]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(getOwnerText(scope.row)), 1)
                  ], 64))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_pagination, {
      "current-page": _ctx.currentPage,
      "page-size": _ctx.pageSize,
      "page-sizes": [5, 10, 20, 50],
      total: _ctx.total,
      layout: "total, sizes, prev, pager, next, jumper",
      background: "",
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:currentPage', $event))),
      "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:pageSize', $event)))
    }, null, 8, ["current-page", "page-size", "total"])
  ]))
}
}

})